/** Coarse pointer / small viewport → treat as mobile play surface. */
export function isMobilePlaySurface(): boolean {
  if (typeof window === 'undefined') return false;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const noHover = window.matchMedia('(hover: none)').matches;
  const narrow = Math.min(window.innerWidth, window.innerHeight) < 820;
  return coarse || noHover || (narrow && 'ontouchstart' in window);
}
